import { useId } from 'react'
import { Callout, Field, Textarea } from 'admination-react'
import { composeMassnahmeSelection } from '@/core/lib/massnahme'
import type { MassnahmeKopf as Massnahme } from '../../api/massnahme'

export const KEINE_MASSNAHME =
  'Die Person ist keiner Maßnahme zugeordnet. Laden Sie die Zuweisungsliste mit der Maßnahmenummer erneut hoch, dann wird die Maßnahme zugeordnet.'

export function MassnahmeKopf({
  massnahme,
  testId,
}: {
  massnahme: Massnahme | null
  testId: string
}) {
  const id = useId()
  if (massnahme === null) {
    return (
      <Field label="Maßnahme" data-testid={`${testId}-hinweis`}>
        <Callout tone="warning" role="status">
          {KEINE_MASSNAHME}
        </Callout>
      </Field>
    )
  }
  return (
    <Field label="Maßnahme" htmlFor={id} data-testid={testId}>
      <Textarea
        id={id}
        className="is-frozen"
        rows={1}
        readOnly
        value={composeMassnahmeSelection(massnahme.nummer, massnahme.bezeichnung)}
      />
    </Field>
  )
}
